export default __webpack_public_path__ + "static/media/Lochana_Marasinghe_CV.86ff35f4.pdf";